var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.333L8.825 4.508l4.65 4.659H3.333v1.666h10.142l-4.65 4.659L10 16.667 16.667 10 10 3.333z",
    fill: "#7084FF"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjAwMDIgMy4zMzMyNUw4LjgyNTE2IDQuNTA4MjVMMTMuNDc1MiA5LjE2NjU4SDMuMzMzNVYxMC44MzMzSDEzLjQ3NTJMOC44MjUxNiAxNS40OTE2TDEwLjAwMDIgMTYuNjY2NkwxNi42NjY4IDkuOTk5OTJMMTAuMDAwMiAzLjMzMzI1WiIgZmlsbD0iIzcwODRGRiIvPgo8L3N2Zz4K";
export { SvgArrowForward as ReactComponent };